export const NIANTIC_TERMS_URL = "https://nianticlabs.com/terms";
export const NIANTIC_PRIVACY_URL = "https://nianticlabs.com/privacy";
